var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Form',{attrs:{"form":_vm.form}},[_c('FormItem',[_c('Input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
					'name',
					{
						rules: [
							{ required: true, message: 'Required' },
							{ validator: _vm.checkUniqueness, trigger: 'blur' }
						]
					}
				]),expression:"[\n\t\t\t\t\t'name',\n\t\t\t\t\t{\n\t\t\t\t\t\trules: [\n\t\t\t\t\t\t\t{ required: true, message: 'Required' },\n\t\t\t\t\t\t\t{ validator: checkUniqueness, trigger: 'blur' }\n\t\t\t\t\t\t]\n\t\t\t\t\t}\n\t\t\t\t]"}],attrs:{"maxLength":_vm.entityLengths.name.max}})],1),_c('FormItem',[_c('TextArea',{directives:[{name:"decorator",rawName:"v-decorator",value:(['description', { rules: [] }]),expression:"['description', { rules: [] }]"}],attrs:{"maxLength":_vm.entityLengths.description.max}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }